// extracted by mini-css-extract-plugin
export default {"container":"SubIssueTypeIndicator-module__container__X64fw3O"};